angular
  .module('components.callcenter', [
    'ngStorage'
  ])
  .constant('CONFIG', {
    API: {
      CALLS: 'https://data.gov.sk/api/3/action/datastore_search'
    },
    PRELOAD_RESOURCE: {
      "resource_group_id": "069a1c5e-7243-4e69-844d-f7cfc41e277e",
      "data_correctness": "correct and exact",
      "maintainer": "2DF13D50-0B6F-48BA-884E-BE66DC0A2934",
      "periodicity": "annually",
      "cache_last_updated": null,
      "webstore_last_updated": null,
      "datastore_active": true,
      "id": "c2098147-16f3-41fc-acee-638a31bf3bbf",
      "size": null,
      "valid_from": "",
      "validity_description": "",
      "state": "active",
      "transformed": false,
      "last_modified": null,
      "on_same_domain": true,
      "schema": "",
      "status": "public",
      "periodicity_description": "",
      "hash": "",
      "description": "",
      "format": "CSV",
      "validity": "perm_valid",
      "tracking_summary": { "total": 1, "recent": 1 },
      "mimetype_inner": null,
      "url_type": "upload",
      "active_to": "",
      "data_correctness_description": "",
      "active_from": "",
      "mimetype": null,
      "cache_url": null,
      "name": "Pocty volan\u00ed 112 za rok 2016",
      "created": "2017-03-31T13:07:48.717885",
      "url": "https://data.gov.sk/dataset/ec254f6d-ba3b-4abc-9ae5-6e6bc3b68e00/resource/c2098147-16f3-41fc-acee-638a31bf3bbf/download/poctyvolaniltv112zarok2016.csv",
      "valid_to": "",
      "webstore_url": null,
      "position": 0,
      "revision_id": "06cb0d82-bc67-4b01-b74b-fc36ee053d12",
      "resource_type": null
    }
  });
